/* eslint-disable */

import axios from 'axios';
import { API_URL } from 'config.js';
import { store } from 'store.js';
import { caricamento, aggiornaFatturati, aggiornaFatturatiRaw, errore, aggiornaValuta, aggiornaZona, aggiornaAnni } from 'features/dashboard/dashboardSlice';
import _ from 'lodash';

const API_ANALISI_URL = `${API_URL}/analisi/`;

export const filtraDatiClienti = (dataset, raggruppaPer = 'DescrStato', anno = 2022, cliente) => {
  const datiDaFiltrare = dataset[anno.toString()]?.[cliente];

  const datiFiltrati = _.groupBy(datiDaFiltrare, (dato) => {
    return dato[raggruppaPer];
  });

  let datiDellAnnoPrima = [];

  if(anno.toString() === new Date().getFullYear().toString()){
    console.log("TMLYYY")

   datiDellAnnoPrima = _.groupBy(dataset?.tmly?.[cliente], (dato) => {
    return dato[raggruppaPer];
  });
  } else {
   datiDellAnnoPrima = _.groupBy(dataset[(anno - 1).toString()]?.[cliente], (dato) => {
    return dato[raggruppaPer];
  });
}

  const etichette = Object.keys(datiFiltrati);

  return etichette.map((e) => {
    return {
      etichetta: e,
      valoreTotale: _.sumBy(datiFiltrati?.[e], (o) => {
        return parseFloat(o.Totale, 10);
      }),
      valoreVolumi: _.sumBy(datiFiltrati?.[e], (o) => {
        return parseFloat(o.Volumi, 10);
      }),
      totaleAnnoPrima: _.sumBy(datiDellAnnoPrima?.[e] ?? 0, (o) => {
        return parseFloat(o.Totale, 10);
      }),
      volumiAnnoPrima: _.sumBy(datiDellAnnoPrima?.[e] ?? 0, (o) => {
        return parseFloat(o.Volumi, 10);
      }),
    };
  });
};

export const filtraDati = (dataset, raggruppaPer = 'DescrStato', anno = 2022, disableYear = false) => {
  const datiDaFiltrare = disableYear ? dataset : dataset[anno.toString()];



  const datiFiltrati = _.groupBy(datiDaFiltrare, (dato) => {
    return dato[raggruppaPer];
  });

  let etichette = Object.keys(datiFiltrati);


  if (disableYear) {
    return etichette.map((e) => {
      return {
        etichetta: e,
        valoreTotale: _.sumBy(datiFiltrati?.[e], (o) => {
          return parseFloat(o.Totale, 10);
        }),
        valoreVolumi: _.sumBy(datiFiltrati?.[e], (o) => {
          return parseFloat(o.Volumi, 10);
        }),
        totaleAnnoPrima: 0,
        volumiAnnoPrima: 0,
      };
    });
  }


  let datiDellAnnoPrima = []
  
  
  if(anno?.toString() === new Date().getFullYear().toString()){
    console.log("TMLYYY")

   datiDellAnnoPrima =_.groupBy(dataset?.tmly, (dato) => {
    return dato[raggruppaPer];
  });
  } else {
   datiDellAnnoPrima = _.groupBy(dataset[(anno - 1).toString()], (dato) => {
    return dato[raggruppaPer];
  });
}

  etichette = _.union(etichette, Object.keys(datiDellAnnoPrima))


  return etichette.map((e) => {
    return {
      etichetta: e,
      valoreTotale: _.sumBy(datiFiltrati?.[e], (o) => {
        return parseFloat(o.Totale, 10);
      }),
      valoreVolumi: _.sumBy(datiFiltrati?.[e], (o) => {
        return parseFloat(o.Volumi, 10);
      }),
      totaleAnnoPrima: datiDellAnnoPrima?.[e] ? _.sumBy(datiDellAnnoPrima?.[e], (o) => {
        return parseFloat(o.Totale, 10);
      }) : 0,
      volumiAnnoPrima: datiDellAnnoPrima?.[e] ? _.sumBy(datiDellAnnoPrima?.[e], (o) => {
        return parseFloat(o.Volumi, 10);
      }) : 0,
    };
  });
};

export const filtraDatiPerZona = (s, a) => {
  const datiDaFiltrare = s.fatturatiRaw[s.anno.toString()];

  const datiFiltrati = _.groupBy(
    datiDaFiltrare.filter((b) => (a !== 'all' ? a === b?.Zone : true)),
    (dato) => {
      return dato?.Type;
    }
  );

  let datiDellAnnoPrima;
  if(s.anno?.toString() == new Date().getFullYear()?.toString()){
    console.log("TMLYYY")
   datiDellAnnoPrima = _.groupBy(s.fatturatiRaw?.tmly, (dato) => {
    return dato?.Type;
  });
  } else {

   datiDellAnnoPrima = _.groupBy(s.fatturatiRaw[(s.anno - 1).toString()], (dato) => {
    return dato?.Type;
  });
  }

  const etichette = Object.keys(datiFiltrati);

  return etichette.map((e) => {
    return {
      etichetta: e,
      valoreTotale: _.sumBy(datiFiltrati[e], (o) => {
        return parseFloat(o.Totale, 10);
      }),
      valoreVolumi: _.sumBy(datiFiltrati[e], (o) => {
        return parseFloat(o.Volumi, 10);
      }),
      totaleAnnoPrima: _.sumBy(datiDellAnnoPrima?.[e] ?? 0, (o) => {
        return parseFloat(o.Totale, 10);
      }),
      volumiAnnoPrima: _.sumBy(datiDellAnnoPrima?.[e] ?? 0, (o) => {
        return parseFloat(o.Volumi, 10);
      }),
    };
  });
};

export const groupByClienti = (dataset) => {
  const d = Object.entries(dataset);
  let r = {};
  for (const [anno, valori] of d) {
    r = {
      ...r,
      [anno]: _.groupBy(valori, (obj) => obj?.Customer?.trim()),
    };
  }
  return r;
};

export const richiediDati = async () => {
  store.dispatch(caricamento(true));

  const {
    auth: {
      currentUser: { pin, utente },
    },
    dashboard: { raggruppamento, anno },
  } = store.getState();

  const res = await axios.post(API_ANALISI_URL, { utente, pin });
  const {
    data: { successo, errore: messaggioerrore, codice, dati },
  } = res;

  if (!successo) {
    store.dispatch(caricamento(false));

    store.dispatch(errore(messaggioerrore));
  }

  if (successo && dati?.fatturati) {
    store.dispatch(aggiornaFatturatiRaw(dati?.fatturati));
    store.dispatch(aggiornaFatturati(filtraDati(dati?.fatturati ?? {}, raggruppamento, anno)));
    store.dispatch(aggiornaAnni(Object.keys(dati?.fatturati ?? {})))
    store.dispatch(caricamento(false));
    store.dispatch(aggiornaValuta(dati?.fatturati[Object.keys(dati.fatturati)[0]][0]?.Valuta));
  }

  return true;
};
